module.exports = __webpack_public_path__ + "static/media/badge.4e1d5dc4.svg";